import { Skeleton } from '@purpur/library';
import styled from 'styled-components';

import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

export const HeadingSkeleton = styled(Skeleton)`
    height: 3rem;
    margin-bottom: ${getPurpurSpacing('1000')};
`;

export const InputSkeleton = styled(Skeleton)`
    height: 3rem;
    margin-bottom: ${getPurpurSpacing('600')};
`;

export const SubmitSkeleton = styled(Skeleton)`
    width: 10rem;
    height: 3rem;
    margin-bottom: ${getPurpurSpacing('600')};
`;
